module.exports = __webpack_public_path__ + "static/img/RW.ecd08df8.svg";